export default {
    pageName: 'คำร้องการลา',
    leaveType: {
        title: 'ประเภทการลา',
        placeholder: '- เลือกประเภทการลา -',
        single: 'วันเดียว',
        range: 'ช่วงเวลา',
        require: 'กรุณาเลือกประเภทการลา'
    },
    startDate: {
        title: 'วันที่เริ่มต้น',
        placeholder: '- เลือกวันที่เริ่มต้น -'
    },
    endDate: {
        title: 'วันที่สิ้นสุด',
        placeholder: '- เลือกวันที่สิ้นสุด -',
        require: 'กรุณากรอกวันที่สิ้นสุด'
    },
    attachFile: {
        title: 'แนบไฟล์',
        select: 'รูปภาพ'
    },
    reason: {
        title: 'เหตุผล',
        placeholder: 'รายละเอียดของการลา',
        invalid: 'เหตุผลจำกัด 255 ตัวอักษร',
        require: 'กรุณากรอกเหตุผล'
    },
    button: {
        cancel: 'ยกเลิก',
        submit: 'บันทึก'
    },
    modalSuccess: {
        title: 'ส่งข้อมูลสำเร็จ',
        body: 'ส่งคำร้องสำเร็จ',
        btnOk: 'ยืนยัน'
    },
    modalFail: {
        title: 'ขออภัย ไม่สามารถดำเนินการได้',
        body: '',
        btnOk: 'ปิด'
    },
    uploadYourPhoto: '* อัปโหลดไฟล์แนบของคุณ',
    successModal: 'ส่งคำร้องสำเร็จ'
}
